/* tslint:disable */
/* eslint-disable */
/**
 * Tanagra Service API
 * github.com/DataBiosphere/tanagra
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureSetCloneInfo
 */
export interface FeatureSetCloneInfo {
    /**
     * ID of the study, immutable
     * @type {string}
     * @memberof FeatureSetCloneInfo
     */
    destinationStudyId?: string;
    /**
     * Human readable name of the feature set
     * @type {string}
     * @memberof FeatureSetCloneInfo
     */
    displayName?: string;
    /**
     * Description of the feature set
     * @type {string}
     * @memberof FeatureSetCloneInfo
     */
    description?: string;
}

/**
 * Check if a given object implements the FeatureSetCloneInfo interface.
 */
export function instanceOfFeatureSetCloneInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FeatureSetCloneInfoFromJSON(json: any): FeatureSetCloneInfo {
    return FeatureSetCloneInfoFromJSONTyped(json, false);
}

export function FeatureSetCloneInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureSetCloneInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'destinationStudyId': !exists(json, 'destinationStudyId') ? undefined : json['destinationStudyId'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function FeatureSetCloneInfoToJSON(value?: FeatureSetCloneInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'destinationStudyId': value.destinationStudyId,
        'displayName': value.displayName,
        'description': value.description,
    };
}

